import { Icon } from '@iconify/react'
import TextArea from 'antd/es/input/TextArea'
import classNames from 'classnames'
import styles from './general-note.module.scss'

type Props = {
  value: string
  isEditing: boolean
  disableActions: boolean
  onDisabledClick?: () => void
  isSaving?: boolean
  autosaveLabel: string
  autosaveStatus: 'idle' | 'saving' | 'saved' | 'error'
  onStartEdit: () => void
  onChange: (value: string) => void
  onCancel?: () => void
  onSave?: () => Promise<void> | Promise<any>
}

export const GeneralNote = ({
  value,
  isEditing,
  disableActions,
  onDisabledClick,
  autosaveLabel,
  autosaveStatus,
  onStartEdit,
  onChange,
}: Props) => {
  const noteContent = (
    <>
      <div className={styles.icon}>
        <Icon icon='si:ai-note-duotone' width={32} height={32} />
      </div>
      <div className={styles.textWrapper}>
        <span className={styles.label}>General note: </span>
        {!isEditing && <span className={styles.noteText}>{value || 'No note added yet'}</span>}
      </div>
    </>
  )

  return (
    <div className={styles.section}>
      <div className={styles.display}>
        {!disableActions ? (
          <button
            type='button'
            className={classNames(styles.content, styles.contentButton)}
            onClick={onStartEdit}>
            {noteContent}
          </button>
        ) : onDisabledClick ? (
          <button
            type='button'
            className={classNames(
              styles.content,
              styles.contentButton,
              styles.contentButtonDisabled,
            )}
            onClick={onDisabledClick}>
            {noteContent}
          </button>
        ) : (
          <div className={classNames(styles.content, styles.contentDisabled)}>{noteContent}</div>
        )}
      </div>
      {isEditing && (
        <>
          <div className={styles.formGroup}>
            <TextArea
              rows={5}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder='Type here...This note will NOT SHOW in medical chart.'
              disabled={disableActions}
            />
          </div>
          <div className={styles.statusRow}>
            <span
              className={classNames(styles.statusLabel, {
                [styles.statusLabelSaving]: autosaveStatus === 'saving',
                [styles.statusLabelSaved]: autosaveStatus === 'saved',
                [styles.statusLabelError]: autosaveStatus === 'error',
              })}>
              {autosaveLabel}
            </span>
          </div>
        </>
      )}
    </div>
  )
}
